/**
 * 分转元
 * @param val 需要转化元的金额
 */
export function fen2Yuan(val: string | number) {
  const valStr = String(val);
  const pattern = /^[+|-]?[0-9]+$/;
  return pattern.test(valStr) ? (parseFloat(valStr) / 100).toFixed(2) : '0.00';
}

/**
 * 元转分
 * @param val 需要转化分的金额
 */
export function yuan2fen(val: string | number) {
  const valStr = String(val);
  return Math.round(parseFloat(valStr) * 100);
}

/**
 * 格式化金额
 * @param val 需要进行格式化的数额
 * @param bit 进行格式化的小数位数
 * @param includeDecimal 是否包含小数位
 */
export function toCurrency(val: string | number = '', bit = 2, includeDecimal = true) {
  // 分解数据
  const pattern = /^(-?)(\d+)(\.\d+)?$/;
  const matchRT = `${val}`.match(pattern);
  let sign = ''; // 符号
  let integer = '0'; // 整数
  let decimal = '.00'; // 小数
  if (matchRT) {
    sign = matchRT[1] || '';
    integer = matchRT[2] || '0';
    decimal = matchRT[3] || '.00';
  }

  const size = integer.length;
  const mod = size > 3 ? size % 3 : 0;
  let tmp = '';
  const start = 0 === mod ? '' : `${integer.substr(0, mod)},`;
  let flag = 0;

  if (includeDecimal) {
    decimal = fillAfter(decimal, '0', bit + 1).substr(0, bit + 1);
  } else {
    decimal = '';
  }

  for (let i = mod; i < size; i++) {
    tmp += integer.charAt(i);
    flag += 1;
    if (flag % 3 === 0 && i < size - 1) {
      tmp += ',';
      flag = 0;
    }
  }

  return sign + start + tmp + decimal;
};

/**
 * 向后填充
 * @param instr 输入的字符串
 * @param chr 填充的字符
 * @param bit 位数
 */
const fillAfter = (instr: string, chr: string, bit: number) => {
  const len = instr.length;
  const shift = bit - len + 1;
  let str = instr;
  if (shift > 0) {
    const a = new Array(shift);
    str = str + a.join(chr);
  }
  return str;
};

/**
 * 分开数字的整数位和小数位
 * @param number | string
 * @returns [integer, decimal]
 * */
export const splitIntegerAndDecimal = (num: number | string = 0) => {
  const numStr = String(num || '0');
  const splitNumStr = numStr.split('.');
  let decimal;
  const integer = splitNumStr[0];
  decimal = splitNumStr[1] || '00';
  if (decimal.length === 1) {
    decimal += '0';
  }
  return [integer, decimal.slice(0, 2)];
};
